/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureASquareLeftIcon20Solid = forwardRef('ArrowFigureASquareLeftIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M14 2a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h8ZM9.749 6.293a.9.9 0 0 1-.062 1.271L7.994 9.1H14a.9.9 0 1 1 0 1.8H7.994l1.693 1.536a.9.9 0 1 1-1.21 1.333l-2.602-2.362a1.9 1.9 0 0 1 0-2.814L8.477 6.23a.9.9 0 0 1 1.272.062Z" })));
});
